import { useState, useCallback } from "react";
import { Dropdown } from "rsuite";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Dialog } from "components/common/dialog/Dialog";
import { ReactPortal } from "components/common";

import { useRootDispatch, useRootSelector } from "store/hooks";

import { resetUser } from "store/user/user-slice";
import { updateSlide } from "store/common/common-slice";
import { selectAllAccounts } from "store/account/account-selector";

import classes from "./UserDropdown.module.scss";

export const UserDropdown = () => {
  const { logout } = useAuth0();
  const { user } = useRootSelector((state) => state.user);
  const { client } = useRootSelector((state) => state.config);
  const dispatch = useRootDispatch();

  const { t } = useTranslation(["app", "common"]);

  const [openDialog, setOpenDialog] = useState(false);
  const allAccounts = useRootSelector(selectAllAccounts);
  const nav = useNavigate();

  const dialogHandler = useCallback((close: boolean) => {
    setOpenDialog(close);
  }, []);

  const settingsClicked = () => {
    nav(`/${client.customerKey}/dashboard/settings`);
  };

  const logoutClicked = () => {
    setOpenDialog(true);
  };

  const logoutAction = () => {
    dispatch(resetUser());
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}/${client.customerKey}`,
      },
    });
  };

  const changeAccountSlider = () => {
    dispatch(updateSlide({ id: "ManageAccount" }));
  };

  /* const handleAccountChange = (account: string) => {
    const selectedAccount = allAccounts.filter(
      (single: AccountInfo) => single.accountNumber === account
    )[0];
    dispatch(changeAccount(selectedAccount));
  }; */

  const handleSelect = (eventKey: string | undefined) => {
    if (eventKey) {
      switch (eventKey) {
        case "logout":
          logoutClicked();
          break;
        case "settings":
          settingsClicked();
          break;
        case "changeAccount":
          changeAccountSlider();
          break;

        default:
          // eventKey && handleAccountChange(eventKey);
          break;
      }
    }
  };

  const renderTopTitle = (props: any, ref: any) => {
    return (
      <button
        {...props}
        ref={ref}
        className={classes.Button}
        data-testid="user-dropdown-toggle"
      >
        <div className={classes.User_icon} slot="icon">
          <ft-icon
            aria-label="user icon for profile"
            class={classes.Icon}
            title={t("common:user_profile")}
          >
            account_circle
          </ft-icon>
        </div>
        <span className={classes.User_info}>{user?.givenName}</span>
        <div className={classes.Icon_Dropdown} slot="trailingIcon">
          <ft-icon aria-label="menu dropdown icon" class={classes.Icon}>
            arrow_drop_down
          </ft-icon>
        </div>
      </button>
    );
  };

  /*  const renderInnerTitle = (props: any, ref: any) => {
    return (
      <div {...props} ref={ref} className={classes.Item_label}>
        <Dropdown.Item
          icon={<ft-icon class={classes.Item_icon}>account_circle</ft-icon>}
          eventKey={1}
        >
          <span className={classes.Item_label}>
            #{accountInfo?.accountNumber}
          </span>
        </Dropdown.Item>
      </div>
    );
  }; */

  /*  const renderAccounts = (allAccounts: AccountInfo[]) => {
    return allAccounts
      .filter(
        (single: AccountInfo) =>
          single.accountNumber !== accountInfo?.accountNumber
      )
      .map((single: AccountInfo) => (
        <Dropdown.Item
          key={single.accountNumber}
          eventKey={single.accountNumber}
        >
          <ft-icon class={classes.Item_icon}>account_circle</ft-icon>
          <span className={classes.Item_label}>#{single.accountNumber}</span>
        </Dropdown.Item>
      ));
  }; */

  return (
    <div className={[classes.Container, "rsuite-custom"].join(" ")}>
      <Dropdown
        placement="bottomEnd"
        renderToggle={renderTopTitle}
        onSelect={handleSelect}
      >
        {/* {allAccounts?.length > 1 ? (
          <Dropdown
            trigger="hover"
            placement="leftStart"
            renderToggle={renderInnerTitle}
            onSelect={handleSelect}
          >
            {renderAccounts(allAccounts)}
          </Dropdown>
        ) : null} */}
        <Dropdown.Item eventKey={"settings"} data-testid="user-dropdown-settings">
          <ft-icon class={classes.Item_icon}>settings</ft-icon>
          <span className={classes.Item_label}>
            {t("common:account_settings")}
          </span>
        </Dropdown.Item>
        {allAccounts.length > 1 && (
          <Dropdown.Item eventKey={"changeAccount"}>
            <ft-icon class={classes.Item_icon}>change_circle</ft-icon>
            <span className={classes.Item_label}>
              {t("common:switch_account")}
            </span>
          </Dropdown.Item>
        )}
        <Dropdown.Item eventKey={"logout"}>
          <ft-icon class={classes.Item_icon}>logout</ft-icon>
          <span className={classes.Item_label}>{t("app:logout")}</span>
        </Dropdown.Item>
      </Dropdown>
      {openDialog && (
        <ReactPortal wrapperId="logout_dialog">
          <Dialog
            icon="logout"
            dialogClosed={dialogHandler}
            primaryActionLabel={t("app:logout")}
            primaryActionHandler={logoutAction}
            type="warning"
          >
            {t("app:logout_confirmation")}
          </Dialog>
        </ReactPortal>
      )}
    </div>
  );
};
